'use client';

import { ENGLISH_IQ_EVENTS } from '@repo/analytics';
import { trackEvent } from '@repo/web-chrome/lib/analytics';
import type { Dispatch, SetStateAction } from 'react';
import { answerEnglishIqWebSession } from '../actions';
import type { IEnglishIqStoredSession } from '../state';
import { applyEnglishIqAnswerResponse, isEnglishIqTerminalSessionError } from './helper';

interface IUseEnglishIqAnswerParams {
  clearSession: () => void;
  finish: (token?: string) => Promise<void>;
  session: IEnglishIqStoredSession | null;
  setError: Dispatch<SetStateAction<string | null>>;
  setIsBusy: Dispatch<SetStateAction<boolean>>;
  storeCompleting: (token: string) => void;
  storeSession: (session: IEnglishIqStoredSession) => void;
}

export function useEnglishIqAnswer(params: IUseEnglishIqAnswerParams) {
  return async (choice: string): Promise<void> => {
    if (!params.session) {
      return;
    }
    params.setIsBusy(true);
    params.setError(null);
    try {
      const current = params.session;
      const data = await answerEnglishIqWebSession(current.item.id, choice, current.token);
      trackEvent(ENGLISH_IQ_EVENTS.itemAnswered, { index: current.index });
      await applyEnglishIqAnswerResponse({
        current,
        data,
        finish: params.finish,
        storeCompleting: params.storeCompleting,
        storeSession: params.storeSession,
      });
    } catch (error) {
      if (isEnglishIqTerminalSessionError(error)) {
        params.clearSession();
        params.setError('session');
      } else {
        params.setError('answer');
      }
    } finally {
      params.setIsBusy(false);
    }
  };
}
